import { VueConstructor } from 'vue';

import error from './components/error/error.vue';
import paccordiongroup from './components/p-accordion/p-accordion-group.vue';
import paccordion from './components/p-accordion/p-accordion.vue';
import palert from './components/p-alert/p-alert.vue';
import papp from './components/p-app/p-app.vue';
import pautocomplete from './components/p-autocomplete/p-autocomplete.vue';
import pbadge from './components/p-badge/p-badge.vue';
import pbreadcrumbbutton from './components/p-breadcrumb/p-breadcrumb-button.vue';
import pbreadcrumbdot from './components/p-breadcrumb/p-breadcrumb-dot.vue';
import pbreadcrumbpath from './components/p-breadcrumb/p-breadcrumb-path.vue';
import pbreadcrumb from './components/p-breadcrumb/p-breadcrumb.vue';
import pbutton from './components/p-button/p-button.vue';
import pcard from './components/p-card/p-card.vue';
import pcheckbox from './components/p-checkbox/p-checkbox.vue';
import pcheckboxgroup from './components/p-checkbox-group/p-checkbox-group.vue';
import pcode from './components/p-code/p-code.vue';
import pcol from './components/p-col/p-col.vue';
import pconditionalwrapper from './components/p-conditional-wrapper/p-conditional-wrapper.vue';
import pcontainer from './components/p-container/p-container.vue';
import pcurrencyfield from './components/p-currency-field/p-currency-field.vue';
import pdatefield from './components/p-date-field/p-date-field.vue';
import pdatedaypicker from './components/p-date-picker/p-date-day-picker.vue';
import pdatemonthpicker from './components/p-date-picker/p-date-month-picker.vue';
import pdatepicker from './components/p-date-picker/p-date-picker.vue';
import pdateweekpicker from './components/p-date-picker/p-date-week-picker.vue';
import pdatetimefield from './components/p-date-time-field/p-date-time-field.vue';
import pdialogconfirm from './components/p-dialog/p-dialog-confirm.vue';
import pdialognotify from './components/p-dialog/p-dialog-notify.vue';
import pdialogprompt from './components/p-dialog/p-dialog-prompt.vue';
import pdialog from './components/p-dialog/p-dialog.vue';
import pdivider from './components/p-divider/p-divider.vue';
import pdynamicformfields from './components/p-dynamic-form-fields/p-dynamic-form-fields.vue';
import pfieldset from './components/p-fieldset/p-fieldset.vue';
import pfiledrop from './components/p-file-drop/p-file-drop.vue';
import pfileselection from './components/p-file-selection/p-file-selection.vue';
import pformelementmessages from './components/p-form/p-form-element-messages.vue';
import pformelement from './components/p-form/p-form-element.vue';
import pform from './components/p-form/p-form.vue';
import picon from './components/p-icon/p-icon.vue';
import pimg from './components/p-img/p-img.vue';
import plistentry from './components/p-list/p-list-entry.vue';
import plistgroup from './components/p-list/p-list-group.vue';
import plist from './components/p-list/p-list.vue';
import plistview from './components/p-list-view/p-list-view.vue';
import plookup from './components/p-lookup/p-lookup.vue';
import pmenu from './components/p-menu/p-menu.vue';
import pnumberfield from './components/p-number-field/p-number-field.vue';
import poverlay from './components/p-overlay/p-overlay.vue';
import ppagination from './components/p-pagination/p-pagination.vue';
import pchild from './components/p-parent/p-child.vue';
import pparent from './components/p-parent/p-parent.vue';
import pphonefield from './components/p-phone-field/p-phone-field.vue';
import pprogresscircular from './components/p-progress-circular/p-progress-circular.vue';
import pprogresslinear from './components/p-progress-linear/p-progress-linear.vue';
import pradiofield from './components/p-radio-field/p-radio-field.vue';
import pratio from './components/p-ratio/p-ratio.vue';
import prequestalert from './components/p-request-alert/p-request-alert.vue';
import presizable from './components/p-resizable/p-resizable.vue';
import prootportal from './components/p-root-portal/p-root-portal.vue';
import prow from './components/p-row/p-row.vue';
import pselect from './components/p-select/p-select.vue';
import pselectmultiple from './components/p-select-multiple/p-select-multiple.vue';
import pselectionchild from './components/p-selection-parent/p-selection-child.vue';
import pselectionparent from './components/p-selection-parent/p-selection-parent.vue';
import psidedrawer from './components/p-side-drawer/p-side-drawer.vue';
import psurface from './components/p-surface/p-surface.vue';
import ptable from './components/p-table/p-table.vue';
import ptab from './components/p-tabs/p-tab.vue';
import ptabs from './components/p-tabs/p-tabs.vue';
import ptextfield from './components/p-text-field/p-text-field.vue';
import ptextfieldformatted from './components/p-text-field-formatted/p-text-field-formatted.vue';
import ptextarea from './components/p-textarea/p-textarea.vue';
import ptimefield from './components/p-time-field/p-time-field.vue';
import ptoggle from './components/p-toggle/p-toggle.vue';
import ptoolbar from './components/p-toolbar/p-toolbar.vue';
import pfadetransition from './components/p-transition/p-fade-transition.vue';
import pscaletransition from './components/p-transition/p-scale-transition.vue';
import pscrollxreversetransition from './components/p-transition/p-scroll-x-reverse-transition.vue';
import pscrollxtransition from './components/p-transition/p-scroll-x-transition.vue';
import pscrollyreversetransition from './components/p-transition/p-scroll-y-reverse-transition.vue';
import pscrollytransition from './components/p-transition/p-scroll-y-transition.vue';
import pslidexreversetransition from './components/p-transition/p-slide-x-reverse-transition.vue';
import pslidextransition from './components/p-transition/p-slide-x-transition.vue';
import pslideyreversetransition from './components/p-transition/p-slide-y-reverse-transition.vue';
import pslideytransition from './components/p-transition/p-slide-y-transition.vue';

export default {
  install: (Vue: VueConstructor, options: any) => {
    Vue.component('error', error);
    Vue.component('p-accordion-group', paccordiongroup);
    Vue.component('p-accordion', paccordion);
    Vue.component('p-alert', palert);
    Vue.component('p-app', papp);
    Vue.component('p-autocomplete', pautocomplete);
    Vue.component('p-badge', pbadge);
    Vue.component('p-breadcrumb-button', pbreadcrumbbutton);
    Vue.component('p-breadcrumb-dot', pbreadcrumbdot);
    Vue.component('p-breadcrumb-path', pbreadcrumbpath);
    Vue.component('p-breadcrumb', pbreadcrumb);
    Vue.component('p-button', pbutton);
    Vue.component('p-card', pcard);
    Vue.component('p-checkbox', pcheckbox);
    Vue.component('p-checkbox-group', pcheckboxgroup);
    Vue.component('p-code', pcode);
    Vue.component('p-col', pcol);
    Vue.component('p-conditional-wrapper', pconditionalwrapper);
    Vue.component('p-container', pcontainer);
    Vue.component('p-currency-field', pcurrencyfield);
    Vue.component('p-date-field', pdatefield);
    Vue.component('p-date-day-picker', pdatedaypicker);
    Vue.component('p-date-month-picker', pdatemonthpicker);
    Vue.component('p-date-picker', pdatepicker);
    Vue.component('p-date-week-picker', pdateweekpicker);
    Vue.component('p-date-time-field', pdatetimefield);
    Vue.component('p-dialog-confirm', pdialogconfirm);
    Vue.component('p-dialog-notify', pdialognotify);
    Vue.component('p-dialog-prompt', pdialogprompt);
    Vue.component('p-dialog', pdialog);
    Vue.component('p-divider', pdivider);
    Vue.component('p-dynamic-form-fields', pdynamicformfields);
    Vue.component('p-fieldset', pfieldset);
    Vue.component('p-file-drop', pfiledrop);
    Vue.component('p-file-selection', pfileselection);
    Vue.component('p-form-element-messages', pformelementmessages);
    Vue.component('p-form-element', pformelement);
    Vue.component('p-form', pform);
    Vue.component('p-icon', picon);
    Vue.component('p-img', pimg);
    Vue.component('p-list-entry', plistentry);
    Vue.component('p-list-group', plistgroup);
    Vue.component('p-list', plist);
    Vue.component('p-list-view', plistview);
    Vue.component('p-lookup', plookup);
    Vue.component('p-menu', pmenu);
    Vue.component('p-number-field', pnumberfield);
    Vue.component('p-overlay', poverlay);
    Vue.component('p-pagination', ppagination);
    Vue.component('p-child', pchild);
    Vue.component('p-parent', pparent);
    Vue.component('p-phone-field', pphonefield);
    Vue.component('p-progress-circular', pprogresscircular);
    Vue.component('p-progress-linear', pprogresslinear);
    Vue.component('p-radio-field', pradiofield);
    Vue.component('p-ratio', pratio);
    Vue.component('p-request-alert', prequestalert);
    Vue.component('p-resizable', presizable);
    Vue.component('p-root-portal', prootportal);
    Vue.component('p-row', prow);
    Vue.component('p-select', pselect);
    Vue.component('p-select-multiple', pselectmultiple);
    Vue.component('p-selection-child', pselectionchild);
    Vue.component('p-selection-parent', pselectionparent);
    Vue.component('p-side-drawer', psidedrawer);
    Vue.component('p-surface', psurface);
    Vue.component('p-table', ptable);
    Vue.component('p-tab', ptab);
    Vue.component('p-tabs', ptabs);
    Vue.component('p-text-field', ptextfield);
    Vue.component('p-text-field-formatted', ptextfieldformatted);
    Vue.component('p-textarea', ptextarea);
    Vue.component('p-time-field', ptimefield);
    Vue.component('p-toggle', ptoggle);
    Vue.component('p-toolbar', ptoolbar);
    Vue.component('p-fade-transition', pfadetransition);
    Vue.component('p-scale-transition', pscaletransition);
    Vue.component('p-scroll-x-reverse-transition', pscrollxreversetransition);
    Vue.component('p-scroll-x-transition', pscrollxtransition);
    Vue.component('p-scroll-y-reverse-transition', pscrollyreversetransition);
    Vue.component('p-scroll-y-transition', pscrollytransition);
    Vue.component('p-slide-x-reverse-transition', pslidexreversetransition);
    Vue.component('p-slide-x-transition', pslidextransition);
    Vue.component('p-slide-y-reverse-transition', pslideyreversetransition);
    Vue.component('p-slide-y-transition', pslideytransition);
  },
};
